/**
 * PostHog flag gating early navigation to the doc builder on `documentId`
 * (Create Deal + package upload). When OFF or missing, uploads keep the legacy
 * wait-for-ready modal flow. When ON, callers may jump to builder with the
 * soft-gate banner while field detection finishes.
 */
export const ENABLE_EARLY_BUILDER_OPEN_FEATURE_FLAG =
  'enable-early-builder-open' as const;
